module.exports = __webpack_public_path__ + "static/media/menu1.aa6b92dd.png";